import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  background?: string;
  color?: string;
};

const AvatarTwo: FC<Props> = ({
  background = colors['--slate'],
  color = colors['--body'],
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ background, borderRadius: '9px' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3096 15.1976C20.3096 14.776 19.9656 14.4342 19.5413 14.4342L18.9266 14.4342C18.5023 14.4342 18.1583 14.776 18.1583 15.1976L18.1583 15.8464C18.1583 16.268 18.5023 16.6097 18.9266 16.6098L19.5413 16.6098C19.9656 16.6098 20.3096 16.268 20.3096 15.8464L20.3096 15.1976Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4818 15.1975C15.4818 14.776 15.1378 14.4342 14.7135 14.4342L14.0988 14.4342C13.6745 14.4342 13.3305 14.776 13.3305 15.1975L13.3305 15.8464C13.3305 16.268 13.6745 16.6097 14.0988 16.6097L14.7135 16.6097C15.1378 16.6097 15.4818 16.268 15.4818 15.8464L15.4818 15.1975Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2113 13.8297C15.2113 13.4048 15.5526 13.0604 15.9737 13.0604L16.5837 13.0604C17.0048 13.0604 17.3461 12.716 17.3461 12.2912L17.3461 11.7912C17.3461 11.3664 17.6875 11.022 18.1086 11.022L20.8916 11.022C21.3126 11.022 21.654 11.3664 21.654 11.7912L21.654 17.0989C21.654 17.5237 21.9954 17.8681 22.4165 17.8681L23.1027 17.8681C23.5238 17.8681 23.8651 17.5237 23.8651 17.0989L23.8651 11.7912C23.8651 11.3664 24.2065 11.022 24.6276 11.022L25.2375 11.022C25.6586 11.022 26 11.3664 26 11.7912L26 17.2527C26 17.6776 25.6586 18.022 25.2375 18.022L24.6276 18.022C24.2065 18.022 23.8651 18.3664 23.8651 18.7912L23.8651 19.2527C23.8651 19.6776 23.5238 20.022 23.1027 20.022L15.9737 20.022C15.5526 20.022 15.2113 19.6776 15.2113 19.2527L15.2113 13.8297ZM18.7567 13.1758C19.1778 13.1758 19.5191 13.5202 19.5191 13.9451L19.5191 17.0989C19.5191 17.5237 19.1778 17.8681 18.7567 17.8681L18.1086 17.8681C17.6875 17.8681 17.3461 17.5237 17.3461 17.0989L17.3461 13.9451C17.3461 13.5202 17.6875 13.1758 18.1086 13.1758L18.7567 13.1758Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7887 13.8297C16.7887 13.4048 16.4474 13.0604 16.0263 13.0604L15.4163 13.0604C14.9952 13.0604 14.6539 12.716 14.6539 12.2912L14.6539 11.7912C14.6539 11.3664 14.3125 11.022 13.8914 11.022L11.1084 11.022C10.6873 11.022 10.346 11.3664 10.346 11.7912L10.346 17.0989C10.346 17.5237 10.0046 17.8681 9.58353 17.8681L8.89732 17.8681C8.47623 17.8681 8.13487 17.5237 8.13487 17.0989L8.13487 11.7912C8.13487 11.3664 7.79351 11.022 7.37242 11.022L6.76245 11.022C6.34136 11.022 6 11.3664 6 11.7912L6 17.2527C6 17.6776 6.34136 18.022 6.76245 18.022L7.37242 18.022C7.79351 18.022 8.13487 18.3664 8.13487 18.7912L8.13487 19.2527C8.13487 19.6776 8.47623 20.022 8.89732 20.022L16.0263 20.022C16.4474 20.022 16.7887 19.6776 16.7887 19.2527L16.7887 13.8297ZM13.2433 13.1758C12.8222 13.1758 12.4809 13.5202 12.4809 13.9451L12.4809 17.0989C12.4809 17.5237 12.8222 17.8681 13.2433 17.8681L13.8914 17.8681C14.3125 17.8681 14.6539 17.5237 14.6539 17.0989L14.6539 13.9451C14.6539 13.5202 14.3125 13.1758 13.8914 13.1758L13.2433 13.1758Z"
      fill={color}
    />
  </svg>
);

export default AvatarTwo;
